// State → good/bad/warning bucket lookup derived from a tag's LLM
// classification. React-free so both the detail panel and the health
// evaluator (`tag-health.ts`) share one definition.

import type { TagClassificationRecord } from '@axilon-apps/domains-ontology-ui-state'

export type StateBucket = 'good' | 'bad' | 'warning'

// Build a case-insensitive state → bucket lookup from a classification.
// Returns null when the classification carries no state buckets (numeric
// tags, or the model couldn't place any state).
export function makeBucketFor(
  classification: TagClassificationRecord | undefined
): ((state: string) => StateBucket | null) | null {
  if (!classification) return null
  const map = new Map<string, StateBucket>()
  for (const s of classification.goodStates) map.set(s.toLowerCase(), 'good')
  for (const s of classification.badStates) map.set(s.toLowerCase(), 'bad')
  for (const s of classification.warningStates) map.set(s.toLowerCase(), 'warning')
  if (map.size === 0) return null
  return (state: string) => map.get(state.toLowerCase()) ?? null
}
